export default class Quote {
    constructor() {
        this.url = '/o/rest/quotes/';
        this.currency = '$';
        this.render = document.querySelector('.header-handler__box-rates');
    };

    init(refresh = false) {
        if (!this.render) {
            return;
        }

        if (refresh) {
            const node = document.querySelector('[quote-box]');
            node.classList.add('header-handler__box--is-loading');
        }

        this.get()
            .then((data) => {
                if (data.length === 0) {
                    Promise.reject('Data quote response is empty');
                }

                return this.createBoxeRate(data);
            })
            .then((boxesTemplate) => {
                if (boxesTemplate.length > 0 && this.render) {
                    const node = this.render;
                    node.innerHTML = '';
                    boxesTemplate.forEach(box => node.innerHTML += box);
                }
            })
            .then(() => {
                const node = document.querySelector('[quote-box]');
                if (!node) {
                    Promise.reject();
                }

                setTimeout(() => {
                    node.classList.remove('header-handler__box--is-loading');
                }, 1000);

                setTimeout(() => {
                    this.init(true);
                }, 30000);

                Promise.resolve();
            })
            .catch((error) => {
                console.error('Something went wrong with this request', error);

                setTimeout(() => {
                    this.init(true);
                }, 30000);

            });
    }
    refresh() {
        this.init(true);
    }
    get() {
        return fetch(this.url, {credentials: 'include'})
            .then(response => response.json())
            .then(data => {
                const quotes = data.Quotes;

                if (quotes && quotes.length > 0) {
                    return quotes;
                }
            })
            .catch(error => {
                console.error('Something went wrong with request', error);
            });
    }

    /**
     * createBoxeRate - return an array of stringify template
     *
     * @param {Array[{Object}]} [data=null]
     * @returns {Array[{Object}]} return an array of stringify template
     * @memberof Quote
     */
    createBoxeRate(data = null) {
        if (!data) {
            return;
        }
        /*eslint-disable */
        return data.map((item) => {
            const variationClassName = this.getVariationClassName(item.Trend);
            const label = this.render.getAttribute('quote-i18n-label');

            return `
                <div class="header-handler__box-rate">
                    <div class="header-handler__box-label">
                        <span quote-rate-ExchangeName>${item.ExchangeName}</span> : <span quote-rate-QuoteName>${item.QuoteName}</span>
                    </div>
                    <div class="header-handler__box-value">
                        <span class="header-handler__box-value-last" quote-rate-Last>
                            ${parseFloat(item.Last).toFixed(2)} ${this.currency}
                        </span>
                        <span class="header-handler__box-value-variation ${variationClassName}" quote-rate-PercentChange>
                        ${item.PercentChange > 0
                            ? `+${parseFloat(item.PercentChange).toFixed(2)}`
                            : parseFloat(item.PercentChange).toFixed(2)
                        }
                        </span>
                    </div>
                    <p class="header-handler__box-last-update">
                        ${this.formatDate(item.LastTradeTime)}
                    </p>
                </div>
            `;
        });
        /*eslint-enable */
    }

    /**
     * formatDate - Transform iso date to dd/mm/yyyy
     *
     *
     * @param {String} [date=null]
     * @returns {String} String date formated as follow dd/mm/yyyy
     * @memberof Quote
     */
    formatDate(date = null) {
        if (!date) {
            return;
        }

        const desiredDate = new Date(date);
        // Add 1 because month start at 0
        const month = String(('0' + (desiredDate.getMonth() + 1)).slice(-2));
        const day = String(('0' + desiredDate.getDate()).slice(-2));
        const year = String(desiredDate.getFullYear());
        const hours = String(('0' + desiredDate.getHours()).slice(-2));
        const minutes = String(('0' + desiredDate.getMinutes()).slice(-2));

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }

    /**
     * getVariationClassName - Return a bemify className
     *
     * @param {String} [trend=null]
     * @returns
     * @memberof Quote
     */
    getVariationClassName(trend = null) {
        const baseClassName = 'header-handler__box-value-variation';

        switch (trend) {
            case 'DECREASE':
                return `${baseClassName}--decrease`;
            case 'INCREASE':
                return `${baseClassName}--increase`;
            default:
                return '';
        }
    }
};



// WEBPACK FOOTER //
// ./src/main/js/components/quote.js